import { render, staticRenderFns } from "./ReleaseInfo.vue?vue&type=template&id=79b117d5&scoped=true&"
import script from "./ReleaseInfo.vue?vue&type=script&lang=js&"
export * from "./ReleaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseInfo.vue?vue&type=style&index=0&id=79b117d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b117d5",
  null
  
)

export default component.exports